import { render, staticRenderFns } from "./Especialidades.vue?vue&type=template&id=37a50eda"
import script from "./Especialidades.vue?vue&type=script&lang=js"
export * from "./Especialidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports